import Util from 'src/util'

class ShuffleLetter {
  constructor(id, goalText, delay, speed, rollNum = 20) {
    this.fontArr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcefghijklmnopqrstuvwxyz1234567890‘?’“!”(%)[#]{@}/&\<-+÷×=>:;,.*'.split('');
    this.id = id;
    this.goalText = goalText;
    this.text = ' ';
    this.fontArr = Util.shuffle(this.fontArr);
    this.state = 'HIDE';
    this.oldState = ' '
    this.defDelay = delay
    this.delay = delay;
    this.defRollNum = rollNum
    this.rollNum = rollNum;
    
    this.rollSpeed = 0.5; // 0 - 1
  }
  reset() {
    this.text = ' '
    this.rollNum = this.defRollNum
    this.delay = this.defDelay
  }
  roll(time) {
    if (Math.floor(time) % 2 == 0) {
      this.text = this.fontArr[Math.floor(Math.random() * this.fontArr.length)];
      this.rollNum--;
    }
  }
  changeState() {
    switch (this.state) {
      case 'HIDE':
        break;
      case 'SHOW':
        this.text = this.goalText;
        break;
      case 'PRE_ROLL_IN':
        break;
      case 'PRE_ROLL_OUT':
        break;
      case 'ROLL_IN':
        break;
      case 'ROLL_OUT':
        break;
      default:
        break;
    }
  }
  render(time) {
    this.oldState = this.state;
    switch (this.state) {
      case 'HIDE':
        break;
      case 'SHOW':
        break;
      case 'PRE_ROLL_IN':
        this.delay--;
        if (this.delay < 1) {
          this.state = 'ROLL_IN';
        }
        break;
      case 'PRE_ROLL_OUT':
        this.delay--;
        if (this.delay < 1) {
          this.state = 'ROLL_OUT';
        }
        break;
      case 'ROLL_IN':
        if (this.rollNum > 0) {
          this.roll(time);
        } else {
          this.state = 'SHOW';
        }
        break;
      case 'ROLL_OUT':
        if (this.rollNum > 0) {
          this.roll(time);
        } else {
          this.text = ' ';
          this.state = 'HIDE';
        }
        break;
      default:
        break;
    }
    
    if (this.state != this.oldState) {
      this.changeState();
    }
  }
}
export default ShuffleLetter